import React, { FC } from 'react';
import { TEventsListingItem, TEventsListingItemData } from '../../types/eventsListing.types';
import EventCard from '../eventCard';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import AnalyticsVisibleEvent from '../../../@shared/analyticsVisibleEvent';

const EventCardList: FC<{ items: TEventsListingItem[]; itemData: TEventsListingItemData; rendering?: ComponentRendering }> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul className="events-listing__card-list">
      {props.items.map((item,index) => {
        return (
          <li className="events-listing__card" key={`${item?.id}`}>
            <AnalyticsVisibleEvent className="events-listing__card-wrapper" rendering={props.rendering} title={item.title} template={'“Events Listing'}>
              <EventCard {...item} itemData={props.itemData} index={index}/>
            </AnalyticsVisibleEvent>
          </li>
        );
      })}
    </ul>
  );
};

export default EventCardList;
